<template>

	<div v-if="call && call.id">
		
		<fullscreen ref="fullscreen" class="chat-box" fullscreenClass="fullscreen" @change="toggleFullscreen">
			<button class="btn btn-outline-light btn-fullscreen" @click="$refs.fullscreen.toggle()">
				<i class="fa fa-expand" v-if="!fullscreen"></i>
				<i class="fa fa-compress" v-if="fullscreen"></i>
			</button>

			<div class="user-data">
				<h3>{{ call.client.name }}</h3>
				<h4>{{ elapsedTime }}</h4>
			</div>
			<!-- <div class="logo"></div> -->

			<div class="chat-container" >
				
				<Session :sessionId="call.vonageSessionId" :apiKey="call.vonagePublicKey" :token="call.vonageToken" :shareScreen="shareScreen" :muted="muted" @sessionEnd="videocallEnd" />				
			</div>

			<div class="button-bar">
				<!-- <button class="btn btn-outline-light" v-b-tooltip.hover placement="top" title="Compartir pantalla" @click="shareScreenToggle()">
					<i class="icon icon-share-screen-off" v-if="shareScreen"></i>
					<i class="icon icon-share-screen-on" v-if="!shareScreen"></i>
				</button> -->

				<button class="btn btn-outline-light" @click="muteToggle()" v-b-tooltip.hover placement="top" title="Silenciar">
					<i class="fa fa-microphone" v-if="!muted"></i>
					<i class="fa fa-microphone-slash" v-if="muted"></i>
				</button>
				<button class="btn btn-danger btn-hangout" v-b-tooltip.hover placement="top" title="Finalizar llamada" @click="videocallEnd()">
					<i class="fa fa-phone"></i>
				</button>
			</div>
		</fullscreen>
	</div>

</template>

<script>
import gql from 'graphql-tag'
import Session from '@/components/VideoVonage/Session'

export default {
	name: 'Video',
	components: {
		Session,
	},
	
	data() {
		return {
			loading: false,
			shareScreen: false,
			muted: false,
			fullscreen: false,
			now: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
			tz: new Date().getTimezoneOffset() / 60 - 3,
		}
	},
	async mounted() {
		setInterval(() => {
			this.now = this.$moment(this.now)
				.add(1, 'second')
				.format('YYYY-MM-DD HH:mm:ss')
		}, 1000)
	},
	computed: {
		call() {
			return this.$store.state.currentCall
		},
		elapsedTime: function() {
			// tomo tiempo segun el timeslot
			if (this.call.startedAt) {
				var a = this.$moment(this.now)
				var b = this.$moment(this.call.startedAt)
				var diff = a.diff(b)
				return this.$moment.utc(diff).format('mm:ss')
			}
			return null
		},
	},
	
	methods: {
		shareScreenToggle() {
			this.shareScreen = !this.shareScreen
		},
		muteToggle() {
			this.muted = !this.muted
		},
		
		videocallEnd() {
			this.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							callEnd(id: $id) {
								id
							client{
                                id
                                name
                                email
                                phone
                            }
                            vonageSessionId
                            vonageToken
                            status
                            createdAt
							startedAt
							}
						}
					`,
					variables: {
						id: this.call.id,
					},
				})
				.then(({data}) => {
					this.$store.commit('setCurrentCall', data.callEnd)
					
					this.loading = false
				})
		},
		
		toggleFullscreen() {
			this.fullscreen = !this.fullscreen
		},
	},
}
</script>

<style scoped>

.chat-box {
	/* position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px; */
}
.chat-box:after {
	content: '';
	display: block;
	padding-bottom: 100%;
}

.chat-box .user-data {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	padding: 8px;
	z-index: 1200;
	background: rgba(0, 0, 0, 0.5);
	background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0.5)), color-stop(64%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 0)));
	background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: -o-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 64%, rgba(0, 0, 0, 0) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=0 );
}
.chat-box .user-data h3 {
	color: #fff;
	font-size: 1rem;
	font-weight: 400;
	margin-bottom: 4px;
}
.chat-box .user-data h4 {
	color: #fff;
	font-size: 0.8rem;
	font-weight: 400;
}
.chat-box .btns {
	flex-grow: 1;
	display: flex;
	z-index: 1200;
	align-items: center;
	justify-content: flex-end;
	width: calc(100% - 180px);
	margin-left: 180px;
}
.chat-box .btn {
	border-radius: 50%;
	width: 28px;
	height: 28px;
	font-size: 1rem;
	border: none;
	opacity: 0.7;
	margin: 0px 8px;
	padding: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.chat-box .btn:hover {
	opacity: 1;
}
.btn-fullscreen {
	position: absolute;
	top: 14px;
	right: 14px;
	z-index: 1500;
}
.button-bar {
	padding: 6px 6px;
	background-color: #333;
	border-radius: 38px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	bottom: 25px;
	z-index: 1300;
	right: 25px;
}
.fullscreen .button-bar {
	right: auto;
	left: calc(50% - 74px);
}
.button-bar .btn {
	flex-grow: 0;
	flex-shrink: 0;
}
.button-bar .btn-hangout i {
	transform: rotate(134deg);
	font-size: 22px;
}
.button-bar .btn-hangout {
	width: 54px;
    height: 54px;
	opacity: 1;
	margin: -14px -8px -14px 6px;
}
.button-bar .icon {
	width: 24px;
	height: 24px;
	display: block;
	background-size: contain;
	filter: invert(1);
}
.button-bar .btn:hover .icon {
	filter: invert(0);
}
.chat-container /deep/ .OT_publisher {
	position: absolute;
	display: block;
	z-index: 1000;
	bottom: 14px;
	left: 14px;
}
.chat-container /deep/ .OT_subscriber {
	position: absolute;
	bottom: 0px;
	z-index: 500;
	right: 0px;
	left: 0px;
	top: 0px;
}
.logo {
	/* background: url(../assets/img/logo.svg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	width: 265px;
	height: 40px;
	display: none;
	position: absolute;
	top: 18px;
	right: 84px; */
}
.fullscreen .logo {
	display: block;
}
</style>